/*Freshchat code*/
(function (d, w, c) { if(!d.getElementById("spd-busns-spt"))
{ var n = d.getElementsByTagName('script')[0], s = d.createElement('script');
var loaded = false; s.id = "spd-busns-spt"; s.async = "async"; s.setAttribute("data-self-init", "false");
s.setAttribute("data-init-type", "opt"); s.src = 'https://cdn.freshbots.ai/assets/share/js/freshbots.min.js'; 
s.setAttribute("data-client", "c62e08e4b2781e45b308e0472ad38d95d26d8694"); s.setAttribute("data-bot-hash", "8e605cc1c69b24dea1ac741dc9417f1a9ac05c99");
s.setAttribute("data-env", "prod"); s.setAttribute("data-region", "us"); 
if (c) { s.onreadystatechange = s.onload = function () { if (!loaded) { c(); } loaded = true; }; 
} n.parentNode.insertBefore(s, n); } }) (document, window, function () 
{ Freshbots.initiateWidget({ autoInitChat: false, getClientParams: function ()
{ return {"cstmr::eml":"","cstmr::phn":"","cstmr::nm":""}; } }, function(successResponse) { }, function(errorResponse) { }); });


function clickChatContainer() {
    const chatContainer = document.getElementById('mobile-chat-container');
    if (chatContainer) {
        chatContainer.click();
    }
}